import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { CustomDrawer } from 'components/ui';
import { useEditFormStore } from 'stores/local';

import { FieldColumns } from '../../common';

type Props = {
  showOnlySelected: boolean;
};

const RequiredFields: React.FC<Props> = ({ showOnlySelected }: Props) => {
  const { t } = useTranslation();
  const { editFormStore } = useEditFormStore();

  return (
    <CustomDrawer.Body
      collapse
      header={
        <Typography.Text type="secondary">
          {t('editForm.requiredFieldsTitle', {
            count: editFormStore.formStore.catalogStore.requiredFieldsCount,
          })}
        </Typography.Text>
      }
    >
      <FieldColumns
        showOnlySelected={showOnlySelected}
        showGroupTitles
        catalogDrawerControllerStore={
          editFormStore.catalogDrawerControllerStore
        }
        fields={editFormStore.formStore.catalogStore.requiredFields}
      />
    </CustomDrawer.Body>
  );
};

export default observer(RequiredFields);
